import { Redirect, useLocation } from "react-router-dom"
import { AREAS_OFICIAIS, OFICIAIS_LOGIN_PATH } from "@/container/autenticacao/utils/areaOficial"

const PREFIXOS_LEGADOS = Object.values(AREAS_OFICIAIS).map((area) => area.base)

/**
 * Mantém funcionando links antigos de /membros-login e /generais-login
 * (favoritos e e-mails de recuperação), preservando sufixo, query e state.
 */
export function RedirectLoginLegado() {
  const { pathname, search, state } = useLocation()
  const prefixo = PREFIXOS_LEGADOS.find((base) => pathname.startsWith(base)) ?? ""

  return (
    <Redirect
      to={{ pathname: `${OFICIAIS_LOGIN_PATH}${pathname.slice(prefixo.length)}`, search, state }}
    />
  )
}
